import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';
import pageableFactory from '@/store/modules/mixins/pageable';
import crudableFactory from '@/store/modules/mixins/crudable';


const pageable = pageableFactory();
const crudable = crudableFactory();
const defaultState = () => ({
  ...pageable.state,
  ...crudable.state,
});

const usersModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    ...crudable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    CREATE: crudable.actions.createPartialApplication({
      uriRoot: 'users',
      name: 'user',
      props: {
        name: 'name',
        email: 'email',
        groups: 'groups',
        role: 'role',
      },
      isSingular: false,
    }),
    UPDATE: crudable.actions.updatePartialApplication({
      uriRoot: 'users',
      name: 'user',
      props: {
        name: 'name',
        email: 'email',
        groups: 'groups',
        role: 'role',
      },
      isSingular: false,
    }),
    DELETE: crudable.actions.deletePartialApplication({ uriRoot: 'users', name: 'user' }),
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'users',
    }),
    RESET_USER_PASSWORD(state, { user }) {
      return HTTP({
        method: 'put',
        url: `users/${user.id}/password-reset`,
      }).then(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('users.resetPasswordSuccess'), icon: 'check', type: 'success' }));
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('users.resetPasswordFailure'), icon: 'times', type: 'error' }));
      });
    },
  },
  getters: {
    ...pageable.getters,
  },
};

export default usersModule;
